import { AbstractPmsApiService } from "./abstract.service";
import { Supplier } from "../models";

/**
 * @class SupplierPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Supplier>}
 */
export class SupplierPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/supplier(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {Supplier}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new Supplier(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Supplier>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Supplier} supplier
     * @param {Property} property
     * @returns {Promise.<Supplier>}
     */
    create(supplier, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, supplier.toObjectExcept('property', 'country', 'city'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Supplier} supplier
     * @returns {Promise.<Supplier>}
     */
    update(supplier) {
        
        const url = this.url({
            propertyId: supplier.property.id,
            id:         supplier.id
        });
        
        return this.http
                   .put(url, supplier.toObjectExcept('property', 'country', 'city'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Supplier} supplier
     * @returns {Promise.<boolean>}
     */
    delete(supplier) {
        
        const url = this.url({
            propertyId: supplier.property.id,
            id:         supplier.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }

    /**
     * Check if supplier can be deleted
     *
     * @param {Supplier} supplier
     *
     * @returns {Promise.<Object>}
     */
    canBeDeleted(supplier) {

        const url = this.url({
            propertyId: supplier.property.id,
            id:         supplier.id
        });

        return this.http
            .get(url + '/can-be-deleted', {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/supplier.service.js